<template>
	<Card :class="cn(condoCardBodyVariants({ size, variant }), props.class)">
		<CondoCardHeader
			class="group/card z-10"
			:is-mouse-over-card-header="isMouseOverCardHeader"
			v-bind="forwardedProps"
			@mouseover="handleMouseOver"
			@mouseleave="handleMouseLeave"
		>
		</CondoCardHeader>

		<CondoCardFooter :variant="variant" :size="size" :title-as="titleAs" />
	</Card>
</template>

<script lang="ts" setup>
import type { CondoCardProps } from '.';

import { cn } from '@/utils';
import { CONDO_CARD } from '~~/utils/symbols';
import { useForwardProps } from 'reka-ui';

import { condoCardBodyVariants, CondoCardFooter } from '.';
import { Card } from '../ui/card';

const props = withDefaults(defineProps<CondoCardProps>(), {
	titleAs: 'h4'
});

provide(CONDO_CARD, props.condo);

const isMouseOverCardHeader = ref(false);

function handleMouseOver() {
	isMouseOverCardHeader.value = true;
}
function handleMouseLeave() {
	isMouseOverCardHeader.value = false;
}

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>
